import { ApplicationConfig, provideZoneChangeDetection, isDevMode, importProvidersFrom } from '@angular/core';
import { provideRouter, ROUTER_CONFIGURATION, withInMemoryScrolling, withRouterConfig, withViewTransitions } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideServiceWorker } from '@angular/service-worker';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { MockApiInterceptor } from './guards/mock-api.interceptor';
import { Globals } from './globals';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserAnimationsModule),
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes, 
      withViewTransitions({
        skipInitialTransition:true
      }),
      withRouterConfig({}),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
        
      })
    ), 
    provideClientHydration(withEventReplay()), 
    provideHttpClient(withInterceptorsFromDi(), withJsonpSupport(), withFetch()),
    // TEMPORARY: dev-only API mock overrides (see src/app/guards/mock-api.interceptor.ts)
    { provide: HTTP_INTERCEPTORS, useClass: MockApiInterceptor, multi: true },
    provideServiceWorker('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000'            
    }),
    Globals
  ]
};
